import * as moment from 'moment';

export class AppDevice {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.appUserID = json && json.app_user_id || null;
        this.hasPush = json && json.has_push || null;
        this.inactive = json && json.inactive || false;
        this.dataSaveMode = json && json.data_save_mode || null;
        this.deviceTypeID = json && json.device_type_id || null;
        this.deviceID = json && json.device_id || null;
        this.oneSignalID = json && json.onesignal_id || null;
        this.lastlogin = json && json.last_login || null;

        if(this.lastlogin) {
            this.momentLastlogin = moment(this.lastlogin);
        }
    }

    id: number;
    appUserID: number;
    hasPush: boolean;
    inactive: boolean;
    dataSaveMode: boolean;
    deviceTypeID: number;
    deviceID: string;
    oneSignalID: string;
    lastlogin: string;

    momentLastlogin: moment.Moment;

    toJSON() {
        return {
            id: this.id,
            app_user_id: this.appUserID,
            has_push: this.hasPush,
            inactive: this.inactive,
            data_save_mode: this.dataSaveMode,
            device_type_id: this.deviceTypeID,
            device_id: this.deviceID,
            onesignal_id: this.oneSignalID,
            last_login: this.lastlogin
        }
    }
}
